import {Component, input} from '@angular/core';
import {Button} from 'primeng/button';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {CreateTemplateTravellers} from '../create-template-travellers/create-template-travellers';
import {CreateTemplateDetails} from '../create-template-details/create-template-details';
import {CreateTemplateItinerary} from '../create-template-itinerary/create-template-itinerary';
import {TemplateStepCode} from '../../../../datasources/template.datasource';
import {CreateTaStepType} from '../../../../util/app.types';

/** Edits one template step in a dialog, as create-ta-step-modal does for TAs. Fields auto-save. */
@Component({
  selector: 'create-template-step-modal',
  imports: [
    Button,
    CreateTemplateTravellers,
    CreateTemplateDetails,
    CreateTemplateItinerary,
  ],
  templateUrl: './create-template-step-modal.html',
})
export class CreateTemplateStepModal {
  currentStep = input<TemplateStepCode>();

  protected readonly CreateTaStepType = CreateTaStepType;

  constructor(public ref: DynamicDialogRef) {}

  closeDialog(): void {
    this.ref.close();
  }
}
